import { useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

const Searchbar = ({ func, placeholder }) => {
  const [input, setInput] = useState("");

  const handleChange = (e) => {
    setInput(e.target.value);
  };
  const handleClick = () => {
    if (input) {
      func(input);
    }
  };

  return (
    <>
      <div className="input-group h-100">
        <Input
          type="text"
          className="form-control  bg-dark "
          placeholder={placeholder}
          aria-label="Username"
          aria-describedby="basic-addon1"
          onChange={handleChange}
        ></Input>
        <div className="input-group-prepend ">
          <Button
            className="input-group-text h-100  bg-secondary"
            id="basic-addon1"
            onClick={handleClick}
          >
            <FontAwesomeIcon icon={faMagnifyingGlass} inverse />
          </Button>
        </div>
      </div>
    </>
  );
};

export default Searchbar;

const Input = styled.input`
  color: white;
  &:focus {
    color: white;
    border-radius: 8px;
  }
  border-radius: 8px;
  outline: none;
  border: 0.5px solid gray;
  height: 100%;
`;
const Button = styled.span`
  cursor: pointer;
  border: 0.5px solid gray;
`;
